import { getFpid } from './getFpid';
export async function initializeFpid(shouldInitialize, retry = 100) {
    if (shouldInitialize && !shouldInitialize()) {
        if (document.readyState !== 'complete') {
            setTimeout(() => initializeFpid(shouldInitialize, retry), retry);
        }
        return;
    }
    return await getFpid();
}
